module.exports = __webpack_public_path__ + "static/img/download-logo.c58af60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download-logo.png
// module id = cHbU
// module chunks = 0